import React, { useContext } from 'react';
import Input from '../../../components/common/Input';
import { translate, verifyHideCountryItems } from "../../../utils/Common";
import AuthContext from '../../../contexts/auth';
import * as FaIcons from 'react-icons/fa';
import styles from './FormBusinesslInformation.module.css';

const FormBusinesslInformation = ({ 
  userInformation, 
  validateUpdatePwdLocker, 
  setValidateUpdatePwdLocker, 
  validateUpdatePwd 
}) => {
  const userContext = useContext(AuthContext);
  
  const getMainUser = () => `${userInformation.PrimerNombre} ${userInformation.PrimerApellido}`;

  return (
    <div className={styles.container}>
      <div className={styles.formGrid}>
        <Input
          label={translate("global.nameFull")}
          value={userInformation ? (userContext.user?.NombreEmpresa ?? getMainUser()) : ''}
          disabled
          type="text"
          leftIcon={<FaIcons.FaUser size={16} />}
        />
      </div>

      {verifyHideCountryItems(["us"]) && userContext.user?.IdTipoUsuario !== 6 && (
        <div className={styles.lockerSection}>
          <h6 className={styles.sectionTitle}>
            {translate("dashboard.userprofile.business.credLocker")}
          </h6>
          
          <div className={styles.formGrid}>
            <Input
              label={translate("dashboard.userprofile.business.user")}
              value={
                userInformation
                  ? Number(userInformation.IdUsuario) < 99
                    ? `0${userInformation.IdUsuario}`
                    : userInformation.IdUsuario
                  : ''
              }
              disabled
              type="text"
              leftIcon={<FaIcons.FaUser size={16} />}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FormBusinesslInformation;
